import { DUAL } from 'bundles/backoffice/vouchers/helpers/transaction_side_details';

export function rejectUsedBrokerOptions(options, commissions, transactionSide) {
  const usedUserIds = new Set();
  for (const commission of commissions) {
    if (!commission._destroy && (!transactionSide || [transactionSide, DUAL].includes(commission.transactionSide))) {
      usedUserIds.add(commission.broker?.id);
    }
  }

  return options.filter(option => !usedUserIds.has(option.value));
}
